import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/pages/Index';
import TestStart from '@/components/pages/TestStart';
import TestMain from '@/components/pages/TestMain';
import Result from '@/components/pages/Result';
import Recipes from '@/components/pages/Recipes';
import RecipesTest from '@/components/pages/RecipesTest';
import Recipe from '@/components/pages/RecipeItem';
import About from '@/components/pages/About';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',

    routes: [
        // {
        //     path: '/',
        //     name: 'Index',
        //     component: Index
        // },
        {
            path: '/',
            name: 'TestStart',
            component: TestStart
        },
        {
            path: '/test',
            name: 'TestMain',
            component: TestMain
        },
        {
            path: '/result',
            name: 'Result',
            component: Result
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/recipes',
            name: 'Recipes',
            component: Recipes,
        },

        {
            path: '/recipes/:id',
            name: 'Recipe',
            component: Recipe
        },
        {
            path: '/test-recipes',
            name: 'RecipesTest',
            component: RecipesTest
        }
    ]
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js